import { createEventProperties, addEventProperties, createTData, getEventSvcProperties } from '../../../interfaces/traffic/eventProperties';
import { sendEvent } from '@tcc/shared/src/integrations/eventService/eventService';
import { merge } from '@exp/exp-utils/helper/object';

import AbstractEventHandler from '../../csp/handlers/abstractEventHandler';
import config from '@exp/exp-utils/helper/config';
import { stringifyArray } from '@exp/exp-utils/helper/string';
import { MAX_MARKS_MEASURES_TO_SEND } from '@tcc/shared/src/helpers/performance';

class AddPerfHandler extends AbstractEventHandler {

  process() {
    super.process({
      EVENT_SVC: () => { this._handleEventSvc(); }
    });
  }

  _handleEventSvc() {
    sendEvent(
      merge(this.pageEvent.getProperties(), getEventSvcProperties()),
      '/b.aspx');
  }

  _getApiKey() {
    return config.get('tcc.eventBusRigorApiKey');
  }

  _getEvents() {
    // if (input.properties && input.properties.navigationStart) {
    //   return [{
    //     schemaId: RIGOR_PAGE_LOAD_SCHEMA_ID,
    //     data: buildPageLoadEvent(input.properties)
    //   }];
    // }
    // if (input.properties && input.properties.timeToInteractive) {
    //   return [{
    //     schemaId: RIGOR_PAGE_LOAD_DELAYED_SCHEMA_ID,
    //     data: buildPageLoadDelayedEvent(input.properties)
    //   }];
    // }
  }

  preProcess() {
    this.pageEvent = createEventProperties('page.log', createTData(this.data));

    addEventProperties(this.pageEvent, this.data.ALL.type);

    // Hard vs Soft navigation (normal page request vs virtual page request)
    this.pageEvent.set('nav_type', this.data.ALL.nav_type);

    // This handler is reused by multiple perf interfaces and is kept
    // around for legacy functionality (primarily SPAs)
    if (typeof this.data.ALL.properties === 'object') {
      this.pageEvent.merge(this.data.ALL.properties);
    }

    // Merge datalayer extras, which includes an identifier to
    // correlate the hit between downstream systems (hit_id)
    this.pageEvent.merge(this.extras);

    // Stringify for event service GET call
    const marks = this.data.ALL.properties.marks;
    if (marks && marks.length > 0) {
      this.pageEvent.set('marks', stringifyArray(marks, MAX_MARKS_MEASURES_TO_SEND, (mark) => {
        return mark.name + ',' + mark.startTime;
      }));
    }

    // Stringify for event service GET call
    const measures = this.data.ALL.properties.measures;
    if (measures && measures.length > 0) {
      this.pageEvent.set('measures', stringifyArray(measures, MAX_MARKS_MEASURES_TO_SEND, (measure) => {
        return measure.name + ',' + measure.duration;
      }));
    }
  }
}

export default AddPerfHandler;
